import { User } from "@fairfleet/geotab";
import { normalizeSearchText } from "@/utilities/text/normalizeSearchText";
import { getUserDisplayName } from "@/utilities/user/getUserDisplayName";

/** The driver card number lives on the driver key, which the User type does not describe. */
export function extractDriverCardNumber(user: User): string {
  const record = user as unknown as { keys?: unknown[]; employeeNo?: string };
  const tachographKey = (record.keys ?? [])
    .map((k) => k as Record<string, unknown>)
    .find((k) => k.driverKeyType === "Tachograph");

  if (tachographKey) {
    const sn = tachographKey.serialNumber;
    if (typeof sn === "string" && sn.trim().length > 0) return sn.trim();
  }

  return "";
}

export function filterDriversBySearch(drivers: User[], search: string): User[] {
  const tokens = normalizeSearchText(search).split(/\s+/).filter(Boolean);
  if (tokens.length === 0) return drivers;

  return drivers.filter(driver => {
    const haystack = normalizeSearchText(
      `${getUserDisplayName(driver, "lastFirst")} ${driver.name ?? ""} ${extractDriverCardNumber(driver)}`,
    );
    return tokens.every(token => haystack.includes(token));
  });
}

/**
 * Drivers whose employment has not ended at `now`. The shared `useDrivers` also returns archived
 * drivers (needed to name past trips); the tachograph list shows current drivers only.
 */
export function filterActiveDrivers(drivers: User[], now: number): User[] {
  return drivers.filter(driver => !driver.activeTo || new Date(driver.activeTo).getTime() >= now);
}
